export const PRODUCTCOMPLAIN_LOADING = "PRODUCTCOMPLAIN_LOADING";
export const PRODUCTCOMPLAIN_RESET = "PRODUCTCOMPLAIN_RESET";
export const GET_PRODUCTCOMPLAIN = "GET_PRODUCTCOMPLAIN";
export const GET_PRODUCTCOMPLAIN_SUCCESS = "GET_PRODUCTCOMPLAIN_SUCCESS";
export const GET_PRODUCTCOMPLAIN_FAIL = "GET_PRODUCTCOMPLAIN_FAIL";
export const DELETE_PRODUCTCOMPLAIN = "DELETE_PRODUCTCOMPLAIN"
export const DELETE_PRODUCTCOMPLAIN_SUCCESS = "DELETE_PRODUCTCOMPLAIN_SUCCESS"
export const DELETE_PRODUCTCOMPLAIN_FAIL = "DELETE_PRODUCTCOMPLAIN_FAIL"
export const UPDATE_PRODUCTCOMPLAIN = "UPDATE_PRODUCTCOMPLAIN"
export const UPDATE_PRODUCTCOMPLAIN_SUCCESS = "UPDATE_PRODUCTCOMPLAIN_SUCCESS"
export const UPDATE_PRODUCTCOMPLAIN_FAIL = "UPDATE_PRODUCTCOMPLAIN_FAIL"
export const ADD_NEW_PRODUCTCOMPLAIN = "ADD_NEW_PRODUCTCOMPLAIN"
export const ADD_PRODUCTCOMPLAIN_SUCCESS = "ADD_PRODUCTCOMPLAIN_SUCCESS"
export const ADD_PRODUCTCOMPLAIN_FAIL = "ADD_PRODUCTCOMPLAIN_FAIL"